/**
 * @docType function
 * @ngDoc util
 * @name app.util.logger:ExternalLogger
 * @author Brian Riley
 * @date July 24, 2014
 * @copyright 2014 Putnam Inc.
 * @description
 *
 *      ExternalLogger
 *
 *      Uses LogEnhancer functionality to publish instance
 *
 */
import LogEnhancer from "./LogEnhancer";

const ExternalLogger = function () {
    /**
     * @description
     * Determines if the requested console logging method is available, since it is not with IE.
     * @ngdoc method
     * @name app.util.logger:ExternalLogger#constructor
     * @methodOf app.util.logger:ExternalLogger
     *
     * @param {Function} method The request console logging method.
     * @returns {object} Indicates if the console logging method is available.
     * @private
     */
    const prepareLogToConsole = function (method) {
        const console = window.console;
        const logFn = function (message) {
            if (isAvailableConsoleFor(method)) {
                try {
                    // eslint-disable-next-line no-restricted-syntax
                    console[method](message);
                } catch (e) {
                    console.error("Error in console." + method + "():", e);
                }
            }
        };

        return logFn;
    };

    const isFunction = function (fn) {
        return typeof fn === typeof Function;
    };

    const isAvailableConsoleFor = function (method) {
        // crashes in IE8 without developer tools open
        const console = window.console;
        if (!method) {
            throw new Error("isAvailableConsoleFor():: Undefined method provided");
        }

        return console && console[method] && isFunction(console[method]);
    };

    const $log = {
        log: prepareLogToConsole("log"),
        info: prepareLogToConsole("info"),
        warn: prepareLogToConsole("warn"),
        debug: prepareLogToConsole("debug"),
        error: prepareLogToConsole("error"),
        prepareLogToConsole: prepareLogToConsole,
        isFunction: isFunction,
        isAvailableConsoleFor: isAvailableConsoleFor
    };

    // Publish instance of $log simulator; with enhanced functionality
    return new LogEnhancer($log);
};

export default ExternalLogger();
